// Patch A.1 — Shared "Add to Calendar" option group.
// Renders four provider-labelled options for a confirmed trial booking:
//   • Google Calendar / Android
//   • Apple Calendar / iPhone (via .ics)
//   • Outlook Calendar
//   • Download .ics (generic)
// Used on BOTH free direct-booking success and paid Stripe redirect success.
// Do NOT use on enquiry submissions — enquiries are not confirmed.

import { Calendar, Download } from "lucide-react";
import {
  downloadTrialIcs,
  getGoogleCalendarUrl,
  getOutlookCalendarUrl,
} from "../lib/trialIcs";

export function TrialCalendarOptions({ details }) {
  const googleUrl = getGoogleCalendarUrl(details);
  const outlookUrl = getOutlookCalendarUrl(details);

  const btnCls =
    "inline-flex items-center justify-center gap-2 px-4 py-2.5 border border-[#9A7B4F]/40 text-[#3D2B1F] text-[11px] tracking-[0.14em] uppercase hover:border-[#9A7B4F] hover:bg-[#9A7B4F]/5 transition-colors w-full sm:w-auto";

  return (
    <div className="mb-6" data-testid="trial-calendar-options">
      <p className="flex items-center justify-center gap-2 text-[11px] tracking-[0.14em] uppercase text-[#9A7B4F] mb-3">
        <Calendar className="w-3.5 h-3.5" />
        Add to Calendar
      </p>
      <div className="flex flex-col sm:flex-row flex-wrap gap-2 justify-center">
        <a
          href={googleUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={btnCls}
          data-testid="calendar-google-btn"
        >
          Google Calendar
        </a>
        <button
          type="button"
          onClick={() => downloadTrialIcs(details)}
          className={btnCls}
          data-testid="calendar-apple-btn"
        >
          Apple Calendar
        </button>
        <a
          href={outlookUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={btnCls}
          data-testid="calendar-outlook-btn"
        >
          Outlook Calendar
        </a>
        <button
          type="button"
          onClick={() => downloadTrialIcs(details)}
          className={btnCls}
          data-testid="calendar-ics-btn"
        >
          <Download className="w-3 h-3" />
          Download .ics
        </button>
      </div>
      <p className="text-[10px] text-[#676664]/40 mt-3">
        Google Calendar works on Android. Apple Calendar / .ics works on iPhone, Mac, and any calendar app.
      </p>
    </div>
  );
}

export default TrialCalendarOptions;
